import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { UpdateTiming } from "../../../utils/apis/matka/store/store";
import { Context } from "../../../utils/context";

const EditTiming = ({ show, onHide, timingData }) => {
  const [form, setForm] = useState({
    open_time: "",
    close_time: "",
    status: true,
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    if (timingData) {
      setForm({
        open_time: timingData.open_time || "",
        close_time: timingData.close_time || "",
        status: timingData.status,
      });
    }
  }, [timingData]);

  const handleSubmit = async () => {
    try {
      const data = {
        open_time: form.open_time,
        close_time: form.close_time,
        status: form.status,
      };

      const result = await UpdateTiming(timingData.id, data);

      const response = result.data;

      setShowModal({
        code: response.code,
        message: response.data,
      });

      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });

        onHide();
      }, 1000);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Timing</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Open Time</Form.Label>

          <Form.Control
            type="time"
            value={form.open_time}
            onChange={(e) =>
              setForm({
                ...form,
                open_time: e.target?.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Close Time</Form.Label>

          <Form.Control
            type="time"
            value={form.close_time}
            onChange={(e) =>
              setForm({
                ...form,
                close_time: e.target?.value,
              })
            }
          />
        </Form.Group>

        <Form.Check
          type="switch"
          label="Active"
          checked={form.status}
          onChange={(e) =>
            setForm({
              ...form,
              status: e.target.checked,
            })
          }
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>

        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTiming;
